import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

// Bandierine in alto a destra nel pannello utente. Mostra solo le lingue
// attivate dal super-admin; con una sola lingua attiva non mostra nulla,
// perché non ci sarebbe niente da scegliere.
export default function LanguageSwitcher() {
  const { language, setLanguage, availableLanguages } = useLanguage();
  if (availableLanguages.length < 2) return null;

  return (
    <div className="lang-switcher" role="group" aria-label="Language">
      {availableLanguages.map(({ key, label, flag }) => (
        <button
          key={key}
          type="button"
          className={`lang-flag ${language === key ? 'active' : ''}`}
          onClick={() => setLanguage(key)}
          aria-label={label}
          aria-pressed={language === key}
          title={label}
        >
          {flag}
        </button>
      ))}
    </div>
  );
}
